import { createSlice } from "@reduxjs/toolkit";
import { LoginThunk } from "../../middlewares/auth";

const initialState = {
  loading: false,
  authData: {},
};

const authenticationSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUserId(state, action) {
      state.user_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LoginThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(LoginThunk.fulfilled, (state, action) => {
        state.authData = action.payload;
        state.loading = false;
      });
  },
});

export default authenticationSlice.reducer;
export const { setAuthUserId } = authenticationSlice.actions;
